import React, { useState } from 'react'
import { useSelector, useDispatch } from "react-redux";
import { Link } from 'react-router-dom'

import "../styles/verifyaccount.css"
import { requestVerification } from '../../database/actions/account';

const VerifyAccount = () => {
  const { account } = useSelector((state) => state.accounts);
  const [verifPopUP, setVerifPopUp] = useState(false)
    const dispatch = useDispatch()

  const VerifyAcc = () => {
    setVerifPopUp(true)
    dispatch(requestVerification(account?._id));
    console.log("Applied")
  }
  return (
    <>
      <div className="verifyAccount">
        <h2>Account Verification</h2>
        <div className="whatToKnow">
          <h3>What you need to know</h3>
          <ul>
            <li><p>The Verification process is brief and doesn't require much from you.</p></li>
            <li><p>There are no tiers to being a verified user. You only do this once which means you won't be asked to upgrade to premium, standard or something higher later on.</p></li>
            <li><p>You won't be restricted from using our trading tools and options. There are unlimited courses to apply to, trades or transactions. Our advanced trading metrics is always available at your disposal.</p></li>
            <li><p>Your transactions are secured and your trades are 100% assured.</p></li>
            <li><p>Being a verified user means agreeing to our updated Terms and Conditions. What does this mean? Your account is protected by Kroxx and trades are under legal agreement with Binance. </p></li>
            <li><p><span>If you've applied for verification and are yet to be verified after 72hours from application date, Please contact admin via Live chat.</span></p></li>
            <li><p>If you're in need of assistance, contact admin</p></li>
          </ul>
          <p onClick={(e) => VerifyAcc()}>Verify My Account</p>
        </div>
      </div>
      {
        verifPopUP &&
        <div className="verifyApplied">
          <h3>Your have applied for verification. You'll be notified via email/liveChat in a while, please keep in touch. If it takes longer than 48hrs, Contact admin via liveChat for assistance.</h3>
          <Link to={`/${account?.userName}/dashboard/${account?._id}`}>Proceed To Dashbord</Link>
          <h6 onClick={(e) => {setVerifPopUp(false)}}>Go back</h6>
        </div>
      }
    </>
  )
}

export default VerifyAccount